module.exports = __webpack_public_path__ + "h5/img/open-box-bg.e3d66c96.png";